/* Vetlivo auto-scrolling carousels.
   Duplicates each track's items once so the CSS -50% scroll loops seamlessly.
   Used by the trust bar, the UGC video rail and the two review rows. */
(function () {
  'use strict';

  function clone(track) {
    if (track.dataset.vzCloned === '1') return;
    track.dataset.vzCloned = '1';
    Array.prototype.slice.call(track.children).forEach(function (item) {
      var copy = item.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      track.appendChild(copy);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-vz-marquee]').forEach(clone);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: re-clone when a section is re-rendered
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
